import * as React from 'react';
import { ErrorSvg } from '../../components/Assets';
import SolidBlueBtn from '../../components/buttons/SolidBlueBtn';
const Error = () => {
    const onClick =()=>{
        if(navigator.onLine){
            window.location.reload();
        }
    }
    return (
        <div
            className="flex justify-center items-center "
            style={{
                height: "calc(105vh - 100px)",
            }}
        >
            <div className="flex items-center justify-center flex-col px-5 w-full">
                <img src={ErrorSvg} />
                <div className="mt-6 text-darkblue font-bold text-18 ">
                    일시적인 오류가 발생했어요.
                </div>
                <div className="mt-3 text-15 ">
                잠시 후 다시 시도해 주시고
                </div>
                <div className="text-15 ">
                문제가 계속되면 고객센터로 연락해 주세요.
                </div>
                <SolidBlueBtn
                    className="w-[5.5rem] h-[2.313rem] mt-5  flex items-center justify-center"
                    onClick={onClick}
                >
                    다시 시도
                </SolidBlueBtn>
            </div>
        </div>
    );
};
export default Error;